module.exports = __webpack_public_path__ + "fonts/icomoon.71d5bff.ttf";